'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaRiManagementCtrl', function ($scope, $stateParams, $eaCurrentSession, $eaUserProfile) {

  var riPurchasedImpactDashboardId = 'ri.impact';

  /*
   * Handle the dataToken
   */
  $scope.dataToken = $eaCurrentSession.DataToken;

  /*
   Manage the Edit Mode
   */
  $scope.dashboardEditMode = false;

  $scope.toggelEditMode = function() {
    $scope.dashboardEditMode = !$scope.dashboardEditMode;
  };
  
    // load the current user profile
  return $eaUserProfile.load($eaCurrentSession.DataToken).then(function(profile) {

    // collect the available contracts for rendering our navigation
    $scope.AvailableContracts = [];

    $eaUserProfile.getContracts(profile, $stateParams.teamid).forEach(function(contract) {

      // add the contact
      $scope.AvailableContracts.push({
        Name: contract.Definition === 'EA' ? 'EA-' + contract.Enrollment : contract.Name,
        Id: contract.Enrollment,
        Team: contract.Team
      });
    });

    // get the team model
    var teamProfile = $eaUserProfile.getTeam(profile, $stateParams.teamid);

    // set the active dashboard
    $scope.activeDashboard = {
      Id: riPurchasedImpactDashboardId,
      Name: 'Purchase Impact Details',
      Profile: profile,
      Team: $stateParams.teamid,
      ContractId: 'RI:PurchaseImpact',
      Active: true,
      Collection: 'ri'
    }  
  });

});
